import {unifiedImageConfigTest} from './constants/signalmanConstants';

const UNIFIED_IMAGE_CONFIG_TEST_CATEGORIES = [91, 207];

export function unifiedImageConfigTestEnabled() {
  return unifiedImageConfigTest === 'test';
}

export function unifiedImageConfigTestEligible(categoryId) {
  if (!categoryId) {
    return false;
  }

  return (
    unifiedImageConfigTestEnabled() &&
    UNIFIED_IMAGE_CONFIG_TEST_CATEGORIES.includes(Number(categoryId))
  );
}
